module.exports = __webpack_public_path__ + "img/img_poa_blurry.cb015116.png";